"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatCount = exports.MAX_DISPLAYABLE_COUNT = void 0;
var MAX_DISPLAYABLE_COUNT = 10000;
exports.MAX_DISPLAYABLE_COUNT = MAX_DISPLAYABLE_COUNT;

var formatCount = function formatCount(count) {
  if (count >= MAX_DISPLAYABLE_COUNT) {
    return "".concat(MAX_DISPLAYABLE_COUNT, "+");
  }

  return count.toString();
};

exports.formatCount = formatCount;